import axios from "axios";
import { useEffect, useState} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const DeanAnnouncementDetail = () => {
  const navigate = useNavigate()
  const { announcementId } = useParams()
  const [announcement_data, setAnnouncementData] = useState()
  const fetchAnnouncementDetail = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/marketplace/university/announcement/${announcementId}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      });
      // console.log("The response is:",response?.data)
      setAnnouncementData(response?.data);
    } catch (error) {
      console.error("Error fetching publication detail:", error);
      toast.error(error.code)
    }
  };
  useEffect(() => {
    if (!announcementId) return;
    fetchAnnouncementDetail();
  }, [announcementId]);

  const deleteMain = async () => {
    const confirmed = window.confirm('Are you sure you want to delete this announcement?');
    if (!confirmed) return;
    try {

      const res = await axios.delete(`${BASE_URL}/marketplace/university/announcement/${announcementId}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      })
      // console.log("The res is:",res)
      if (res.status === 204 || res.status === 201) {
        alert('Annoucement deleted successfully!')
        navigate("/marketplace/university/announcements")
      }
    } catch (error) {
      console.log("Error while deleting announcement", error)
      toast.error(error.code)
    }
  };
  return (
    <div className="min-h-screen flex justify-center">
      <div className="max-w-5xl w-full bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Image + MAIN Edit/Delete */}
        <div className="relative h-[350px]">
           {announcement_data?.announcement_type === "image" && (
                        <img
                            src={announcement_data?.file}
                            alt={announcement_data?.name}
                            className="w-full h-full object-cover"
                        />
                    )}
                    {announcement_data?.announcement_type === "pdf" && (
                        <iframe
                            src={`${announcement_data?.file}#toolbar=0`}
                            title={announcement_data?.name}
                            className="w-full h-full object-cover"
                            allowFullScreen={true}
                        />
                    )}
                    {announcement_data?.announcement_type === "doc" && (
                        <iframe
                            src={`https://docs.google.com/gview?url=${announcement_data?.file}&embedded=true`}
                            title={announcement_data?.name}
                            className="w-full h-full"
                            
                        />

                    )}
                    {announcement_data?.announcement_type === "video" && (
                        <video
                            src={announcement_data?.file}
                            controls
                            className="w-full h-full object-cover"
                        />
                    )}
                    {announcement_data?.announcement_type === "audio" && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <audio src={announcement_data?.file} controls className="w-full  rounded-[15px] w-full object-contain" />
                        </div>

                    )}
                    {announcement_data?.announcement_type === 'code' && (
                        <div className="w-full h-48 overflow-auto border rounded-xl p-4 bg-gray-50 flex items-center justify-center">
                            <a
                                href={announcement_data?.file} // creates local preview URL
                                //   download={file.name} // optional: lets user download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline"
                            >
                                {announcement_data?.file}
                            </a>
                        </div>
                    )}
          <div className="absolute top-4 right-4 flex gap-2">
            
            <button
              onClick={deleteMain}
              className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          </div>
        </div>
        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">{announcement_data?.title}</h1>
              <p className="text-sm text-gray-500 mt-0.5">Announcemnt Details</p>
            </div>
          </div>
          {/* Description */}
          {announcement_data?.summary && (
            <div className="p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                <p className="text-sm font-semibold text-gray-700">Summary</p>
              </div>
              <p className="text-gray-600">{announcement_data?.summary}</p>
            </div>
          )}
          {announcement_data?.description && (
            <div className="p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                <p className="text-sm font-semibold text-gray-700">Description</p>
              </div>
              <div
                className="text-gray-600"
                dangerouslySetInnerHTML={{ __html: announcement_data.description }}
              />
            </div>
          )}
          {/* Info Cards */}
          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gray-50 p-4 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                </div>
              </div>
              <p className="text-xs text-gray-500 mb-1">Domain</p>
              <p className="font-medium text-gray-900">{announcement_data?.domain}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </div>
              </div>
              <p className="text-xs text-gray-500 mb-1">Maturity</p>
              <p className="font-medium text-gray-900">{announcement_data?.maturity}</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-xl">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                </div>
              </div>
              <p className="text-xs text-gray-500 mb-1">Collaboration</p>
              <p className="font-medium text-gray-900">{announcement_data?.collaboration}</p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default DeanAnnouncementDetail;
